import React, { CSSProperties, PropsWithChildren } from "react";
import {
  setBackgroundColor,
  SetBackgroundColor,
  SetStyle,
  setStyle,
  setShadow,
  SetShadow,
  setBorder,
  SetBorder,
  setAlignItems,
  SetAlignItems,
  setAlignSelf,
  SetAlignSelf,
  setFlex,
  SetFlex,
  setFlexDirection,
  SetFlexDirection,
  setJustifyContent,
  SetJustifyContent,
} from "../../StyleSheet";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

export type CardProps = SetBackgroundColor &
  SetStyle &
  SetShadow &
  SetBorder &
  SetFlex &
  SetAlignSelf &
  SetAlignItems &
  SetJustifyContent &
  SetFlexDirection & {
    className?: string;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    dir?: "ltr" | "rtl";
    style?: CSSProperties;
    ref?: any;
  };

const StyledCard: React.FC<CardProps> = styled.div<CardProps>`
  ${setBackgroundColor};
  ${setBorder};
  ${setFlex};
  ${setAlignSelf};
  ${setAlignItems};
  ${setJustifyContent};
  ${setFlexDirection};
  ${setShadow};
  ${setStyle};
`;

export function Div(props: PropsWithChildren<CardProps>) {
  const { locale, ref, ...restProps } = props;

  const { i18n } = useTranslation();

  return (
    <StyledCard ref={ref} {...restProps} locale={locale || i18n.language} />
  );
}
